import { ICategories } from './Categories';
import { ICreatorInfo } from './Creators';
import { RestBoolean } from './generic';
import { IMeta } from './Meta';

export enum ECollectionVisibility {
  WEBSITE = 0,
  STORE = 1,
  BOTH = 2
}

export type ICollection = {
  id: number;
  name: string;
  description: string;
  banner_url: string;
  logo_image?: string;
  parent_id: string;
  category: ICategories;
  slug: string;
  meta_title: string;
  meta_description: string;
  meta_keywords: string;
  creator_id: number;
  creator: ICreatorInfo;
  created_at: string;
  updated_at: string;
  total_supply?: number;
  featured_image?: string;
};

export type ICollectionWithCategoryAndCreator = {
  id: number;
  banner_url: string;
  blockchain: string | null;
  category: {
    banner_url: string | null;
    created_at: string;
    description: string;
    featured_image: string | null;
    id: number;
    logo_image: string | null;
    meta_description: string;
    meta_keywords: string;
    meta_title: string;
    name: string;
    slug: string;
    updated_at: string;
  };
  chain_address: string | null;
  contract_address: string | null;
  created_at: string;
  creator: ICreatorInfo;
  description: string;
  discord: string | null;
  featured_image: string;
  instagram: string | null;
  is_featured: number;
  logo_image: string;
  medium: string | null;
  meta_description: string;
  meta_keywords: string | null;
  meta_title: string;
  name: string;
  pinterest: string | null;
  slug: string;
  telegram: string | null;
  total_supply: number;
  updated_at: string;
  website: string | null;
};

export type ICollectionWithStats = ICollection & {
  stats: {
    items: number;
    sales: number;
    floor_price: number;
    formatted_floor_price: string;
    volume: number;
    formatted_volume: string;
  };
};

export type IGetCollectionParams = {
  id: string;
  creator_id: string;
  category_id: string;
  is_featured: RestBoolean;
  name: string;
  slug: string;
  sort: string;
  order: string;
  page: number;
  pagination: RestBoolean;
  limit: number;
  is_featured: 0 | 1;
  is_empty_total_saleable_supply: number;
};

export type ICreateCollectionParams = {
  id?: number;
  name: string;
  description: string;
  image: File;
  slug: string;
  category_id?: number;
  meta_title?: string;
  meta_description?: string;
  meta_keywords?: string;
  visibility?: ECollectionVisibility;
};

export type ICollectionListResponse<T = ICollection> = {
  data: T[];
  meta: IMeta;
};

export type TCustomCollection = Pick<ICollection, 'name' | 'slug'> & {
  id: string;
  creator: Pick<ICreatorInfo, 'title' | 'logo_url'>;
};

export type TCustomCategory = Pick<ICategories, 'name' | 'slug'> & {
  id: string;
};

export type TCustomArtist = Pick<ICreatorInfo, 'user_name' | 'title'> & {
  id: string;
};

export type TCollectionRankingType = 'top' | 'all';

export type TCreateCollectionErrors = {
  [K in keyof ICreateCollectionParams]?: string[];
};
